export function generateAccessToken(): string {
    let time: string = Date.now().toString();
    time = time.substr(time.length - 10);
    const random1 = Math.random().toString().substr(2, 11);
    const random2 = Math.random().toString().substr(2, 11);
    return time + random1 + random2;
}

export function generateTrackEventId(): string {
    let time: string = Date.now().toString();
    time = time.substr(time.length - 10);
    const random1 = Math.random().toString().substr(2, 5);
    const random2 = Math.random().toString().substr(2, 5);
    return time + random1 + random2;
}


export function generateId(): string {
    let time: string = Date.now().toString();
    time = time.substr(time.length - 6);
    const random1 = Math.random().toString().substr(2, 2);
    const random2 = Math.random().toString().substr(2, 2);
    return time + random1 + random2;
}